import { useEffect, useState } from "react";
import axios from "axios";
import { useEffectAsync } from "@alphascriptsolutions/client-core";
import { apiBase, authHeaders } from "@/utils/apiClient";
import { slidesProgressSocket } from "@/utils/slides/slidesProgressSocket";
import { logger } from "@/helpers/tslog";
import type { SlidesProgressSnapshot } from "@/utils/slides/slidesTaskpaneContract";


export function useSlideJobProgress(jobId: string): SlidesProgressSnapshot | null {
  const [progress, setProgress] = useState<SlidesProgressSnapshot | null>(null);

  useEffectAsync(async () => {
    if (!jobId || !apiBase()) return;
    try {
      const { data } = await axios.get<{ progress?: SlidesProgressSnapshot }>(
        `${apiBase()}/slide-generation/status`,
        {
          params: { jobId },
          headers: await authHeaders(),
          withCredentials: true,
        },
      );
      if (data.progress) setProgress(data.progress);
    } catch (error) {
      logger.warn("[useSlideJobProgress] hydrate failed; relying on socket", error);
    }
  }, [jobId]);

  useEffect(() => {
    if (!jobId) return () => {};
    return slidesProgressSocket.subscribe(jobId, setProgress);
  }, [jobId]);

  return progress;
}
